<template>
<ViskaseCard v-if="selectedCasing.variant === 'features'">
    <template v-slot:header>
    </template>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row justify-content-start align-items-start p-1" ref="activeCasing">
            <div class="col-12 text-start col-md-6">
                <div class="">
                    <img style="min-width: 50%; min-height:100%;" class="card-img-top" :src="selectedCasing.img" :alt="selectedCasing.name" />
                </div>
            </div>
            <div class="col-12 text-start col-md-6">
                <div v-html="our_perfect_casing" class="fw-bold h3 py-2">
                </div>
                <div class="">
                    <span v-html="if_you_are_using" class="casing-reason fw-bold"></span>
                    <span class="casing-features">
                        <ul>
                            <li class="mt-3" v-for="(item, index) in selectedCasing.reasons_intro" :key="index">
                                {{ item.desc }}
                            </li>
                        </ul>
                    </span>
                    <div class="d-flex justify-content-center justify-content-sm-start">
                        <button @click="gotoFeatures(selectedCasing)" type="button" class="p-2 px-4 btn btn-viskase-orange">
                            <span v-html="read_more_about">
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedLinks.length" class="row text-start">
            <div class="fw-bold h4 pt-5">
                {{offer_also}}
            </div>
            <div v-for="(item, index) in selectedLinks" :key="index" class="col-12 col-md-6 p-sm-5">
                <div>
                    <img style="min-width: 50%; min-height:100%;" class="card-img-top" :src="item.img" :alt="item.name" />
                </div>
                <div class="text-center" @click="setSelectedCasing(item);scrollToTop(); ">
                    <button type="button" class="p-2 px-4 btn btn-viskase-orange">
                        {{ item.alias }}
                    </button>
                </div>
            </div>
        </div>
    </template>
</ViskaseCard>
<ViskaseCard v-if="selectedCasing.variant === 'benefits'">
    <template v-slot:header>
    </template>
    <template v-slot:title>
    </template>
    <template v-slot:default>
        <div class="row justify-content-start align-items-start p-1">
            <div class="col-12 text-start col-md-6 ">
                <div class=" ">
                    <img style="min-width: 50%; min-height:100%;" class="card-img-top" :src="selectedCasing.img" :alt="selectedCasing.name" />
                </div>
            </div>
            <div class="col-12 text-start col-md-6">
                <div class="fw-bold h3">
                    <span class="casing-title">{{ selectedCasing.title }}</span>
                </div>
                <div>
                    <span class="casing-reason" v-if="selectedCasing.description">{{selectedCasing.description}}</span>
                    <div class="casing-features mt-3" v-if="selectedCasing.benefits">
                        <span class="casing-title h3">{{features_and_benefits}}</span>
                        <ul>
                            <li class="mt-3" v-for="(item, index) in selectedCasing.benefits" :key="index">
                                {{ item.desc }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
export default {
  name: "Casings",
  components: {
    ViskaseCard,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    ...mapActions([]),
    ...mapMutations(["setSelectedCasing"]),
    scrollToTop() {
      this.emitter.emit("scroll-to-top");
    },
    gotoFeatures(casing) {
      this.setSelectedCasing(casing);
      if (casing.variant === "features") {
        this.$router.push({
          name: "features",
          params: {
            language: this.$route.params.language,
            product: this.$route.params.product,
            solution: this.$route.params.solution,
            casing: casing.name,
          },
        });
      }
    },
    gotoOfferRequest() {
      this.$router.push({
        name: "offer-request",
        params: {
          language: this.$route.params.language,
          product: this.$route.params.product,
          solution: this.$route.params.solution,
          casing: this.selectedCasing.name,
        },
      });
    },
    gotoMeeting() {
      this.$router.push({
        name: "meeting",
        params: {
          language: this.$route.params.language,
          product: this.$route.params.product,
          solution: this.$route.params.solution,
          casing: this.selectedCasing.name,
        },
      });
    },
  },
  computed: {
    ...mapState([
      "casings",
      "selectedProduct",
      "selectedSolution",
      "selectedCasing",
      "solutionCasings",
      "casingLinks",
      "activeCasings",
      "selectedLinks",
      "cards",
    ]),
    title() {
      return this.cards.casings.title.replace(
        /{selectedProduct}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (
            this.selectedProduct || {
              title: "",
            }
          ).title +
          "</span>"
      );
    },
    our_perfect_casing() {
      return this.cards.casings.our_perfect_casing.replace(
        /{selectedCasing}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (
            this.selectedCasing || {
              title: "",
            }
          ).title +
          "</span>"
      );
    },
    if_you_are_using() {
      return this.cards.casings.if_you_are_using
        .replace(
          /{selectedCasing}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (
              this.selectedCasing || {
                alias: "",
              }
            ).alias +
            "</span>"
        )
        .replace(
          /{selectedCasing}/g,
          "<span class='viskase-orange-text fw-bold'>" +
            (
              this.selectedCasing || {
                title: "",
              }
            ).title +
            "</span>"
        );
    },
    read_more_about() {
      return this.cards.casings.read_more_about.replace(
        /{selectedCasing}/g,
        "<span class='fw-bold'>" +
          (
            this.selectedCasing || {
              title: "",
            }
          ).title +
          "</span>"
      );
    },
    offer_also() {
      return this.cards.casings.offer_also;
    },
    features_and_benefits() {
      return this.cards.casings.features_and_benefits;
    },
  },
};
</script>

<style scoped></style>
